import { ISelectItem } from '@lla-platform/core/core-ui'

export enum TireType {
  NotSet = 'NotSet',
  Bfs = 'Bfs',
  Advanta = 'Advanta',
  Nitto = 'Nitto',
  Kenda = 'Kenda',
  Toyo = 'Toyo',
  Nexen = 'Nexen',
  Kumho = 'Kumho',
  Goodyear = 'Goodyear',
  Conti = 'Conti',
  Michelin = 'Michelin',
  Pirelli = 'Pirelli'
}

export const TireTypeToLabel: { [key: string]: string } = {
  NotSet: '',
  Bfs: 'BFS',
  Advanta: 'Advanta',
  Nitto: 'Nitto',
  Kenda: 'Kenda',
  Toyo: 'Toyo',
  Nexen: 'Nexen',
  Kumho: 'Kumho',
  Goodyear: 'Goodyear',
  Conti: 'Conti',
  Michelin: 'Michelin',
  Pirelli: 'Pirelli'
}

/** A tire program: every TireType except NotSet. */
export type TireProgram = Exclude<TireType, TireType.NotSet>

/** Tire programs in report/column order: enum declaration order, NotSet excluded (mirrors the API). */
export const TirePrograms: TireProgram[] = Object.values(TireType).filter(
  (type): type is TireProgram => type !== TireType.NotSet
)

export const TireTypeItems: ISelectItem[] = TirePrograms.map((program) => ({
  label: TireTypeToLabel[program],
  value: program
}))
